import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Sparkles } from "lucide-react";

/**
 * Hover-triggered "history" panel shown from the logo+brand lockup on the
 * landing page. Content is admin-editable via the Counseltaria Profile
 * panel in the lead admin's dashboard (GET /api/brand-profile).
 */
export default function BrandStoryPanel() {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    api.get("/brand-profile").then(r => setProfile(r.data)).catch(() => {});
  }, []);

  if (!profile) return null;

  return (
    <div className="brand-story-panel" data-testid="brand-story-panel">
      <span className="label-eyebrow inline-flex items-center gap-2">
        <Sparkles className="w-3.5 h-3.5" /> Our story
      </span>
      <h3 className="font-serif-display text-2xl mt-1">{profile.title}</h3>
      <p className="text-sm mt-1" style={{ color: "var(--text-secondary)" }}>{profile.tagline}</p>
      <div className="brand-story-timeline">
        {(profile.milestones || []).map((m, i) => (
          <div key={i} className="brand-story-milestone" data-testid={`brand-story-milestone-${i}`}>
            <div className="text-xs font-semibold uppercase tracking-widest" style={{ color: "var(--brand)" }}>{m.year}</div>
            <div className="text-sm mt-1" style={{ color: "var(--text-primary)" }}>{m.text}</div>
          </div>
        ))}
      </div>
      {profile.closing_note && (
        <p className="text-xs mt-4 pt-4 border-t" style={{ color: "var(--text-secondary)", borderColor: "var(--border-soft)" }}>
          {profile.closing_note}
        </p>
      )}
    </div>
  );
}
